import { createConsumer } from '@rails/actioncable'

// One shared websocket per page; every channel subscription multiplexes over it.
// createConsumer() reads <%= action_cable_meta_tag %> when present and falls back
// to /cable on the current origin. The socket isn't opened until the first
// subscription is created.
export default createConsumer()
